import { AfterViewInit, ChangeDetectionStrategy, Component, ElementRef, Input, OnDestroy, OnInit } from '@angular/core';
import { LMFileuploadBaseComponent } from '@field/fileupload/lm-fileupload-base.component';
import { LMFieldServiceAdapter } from '@app/components';
import { LMUrlUtilService } from '@app/services';

import { LMXLFileUploadService } from '@services/file-upload/lm-xlfile-upload.service';

@Component({
  selector: 'lm-fileupload-soho',
  standalone: false,
  templateUrl: 'lm-fileupload-soho.component.html',
  styleUrls: [ 'lm-fileupload-soho.component.scss' ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class LMFileuploadSohoComponent extends LMFileuploadBaseComponent implements OnInit, AfterViewInit, OnDestroy {
  constructor(
    protected lmFieldServiceAdapter: LMFieldServiceAdapter,
    protected lmUrlUtilService: LMUrlUtilService,
    protected lmXLFileUploadService: LMXLFileUploadService,
    protected elementRef: ElementRef
  ) {
    super(lmFieldServiceAdapter, lmUrlUtilService, lmXLFileUploadService, elementRef);
  }

  ngOnInit() {
    super.ngOnInit();
  }

  ngAfterViewInit() {
    super.ngAfterViewInit();
  }

  ngOnDestroy() {
    super.ngOnDestroy();
  }
}
